"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import makeStyles from "../../theming/make-styles.js";
import makePadding from "../utils/make-padding.js";
export const paddings = {
    small: { x: 12, y: "xs" },
    medium: { x: "md", y: "sm" },
    large: { x: 20, y: 12 },
};
const useStyles = makeStyles()((theme, { color, shadow, size, variant }) => {
    const palette = theme.palette(color).button[variant];
    const padding = makePadding(paddings, theme);
    return {
        button: {
            "display": "inline-flex",
            "alignItems": "center",
            "maxWidth": "100%",
            "fontFamily": "inherit",
            "fontSize": theme.typography.body.fontSize,
            "fontWeight": theme.typography.fontWeights.medium,
            "lineHeight": theme.typography.body.lineHeight,
            "verticalAlign": "middle",
            "userSelect": "none",
            "padding": padding(size, theme.size(1)),
            "color": palette.color,
            "backgroundColor": palette.backgroundColor,
            "border": `${theme.size(1)} solid`,
            "borderColor": palette.borderColor,
            "borderRadius": theme.size(4),
            "&:hover:not(:disabled)": Object.assign({}, palette.hover),
            "&:focus:not(:disabled)": {
                borderColor: palette.focus.borderColor,
                boxShadow: theme.outline(palette.focus.boxShadowColor),
            },
            "&:active:not(:disabled)": Object.assign({}, palette.active),
            "&:disabled": Object.assign({}, palette.disabled),
            "&:not(:disabled)": {
                boxShadow: shadow ? theme.shadow("sm") : "none",
                cursor: "pointer",
            },
            "&:hover, &:focus": {
                textDecoration: "none",
            },
            "&:focus": {
                outline: 0,
            },
            "& > span": {
                flexGrow: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                pointerEvents: "none",
            },
        },
    };
});
export const defaultShadows = {
    filled: true,
    outline: false,
    link: false,
    light: true,
    faded: true,
};
export const ButtonBase = React.forwardRef(function ButtonBase(_a, ref) {
    var { children, className, color = "primary", size = "medium", variant = "filled", shadow = defaultShadows[variant || "filled"] } = _a, props = __rest(_a, ["children", "className", "color", "size", "variant", "shadow"]);
    const { classes, cx } = useStyles({ color, shadow, size, variant });
    return (_jsx("button", Object.assign({ ref: ref, className: cx(classes.button, className), "data-component": "button-base" }, props, { children: children })));
});
export default ButtonBase;
//# sourceMappingURL=button-base.js.map